export { Column } from "primereact/column";
import {
  DataTablePassThroughMethodOptions,
  DataTable as DataTablePrime,
  DataTableProps as DataTablePropsPrime,
  DataTableValueArray,
} from "primereact/datatable";

import { Result } from "@/components/organisms/Result/Result";
import { cn } from "@/styles/cn";
import { CenterLayout } from "@/components/layouts/CenterLayout/CenterLayout";

type DataTableProps = DataTablePropsPrime<DataTableValueArray> & {
  dataKey: string;
  stateKey?: string;
  emptyMessage?: string;
  variant?: "normal" | "excel";
};

const EmptyComponent = ({ message }: { message?: string }) => {
  return (
    <CenterLayout className="absolute bottom-0 left-0 right-0 top-0 overflow-hidden">
      <Result.Empty subTitle={message} />
    </CenterLayout>
  );
};

export function DataTable({
  children,
  emptyMessage,
  variant = "normal",
  pt = {},
  ...props
}: DataTableProps) {
  const isExcelVariant = variant === "excel";
  if (isExcelVariant) {
    pt = {
      thead: () => ({
        className: "bg-[#FAFAFA]",
      }),
      column: {
        headerCell: () => {
          return {
            className: cn("border-y-0", "text-left ", "transition duration-200", "bg-inital"),
          };
        },
      },
      wrapper: ({ props }: DataTablePassThroughMethodOptions<DataTableValueArray>) => ({
        className: cn("scroll", "border-0", {
          relative: props.scrollable,
          "flex flex-col": props.scrollable && props.scrollHeight === "flex",
        }),
      }),
      ...pt,
    };
  }

  return (
    <DataTablePrime
      paginator
      reorderableColumns
      resizableColumns
      scrollable
      className={cn("w-full", { "table--excel": isExcelVariant })}
      currentPageReportTemplate="{first}-{last} de {totalRecords} resultados"
      emptyMessage={<EmptyComponent message={emptyMessage} />}
      paginatorTemplate="CurrentPageReport PrevPageLink PageLinks NextPageLink RowsPerPageDropdown"
      pt={pt}
      rows={15}
      rowsPerPageOptions={[5, 10, 15, 25, 50, 70]}
      stateStorage="session"
      {...props}
    >
      {children}
    </DataTablePrime>
  );
}
